import { version } from '../../../package.json';
import window from 'global/window';
import document from 'global/document';
import jsonp from 'jsonp';
import * as browser from '@emav-util/browser.js';
import AVStatistic from './av-statistic';
export var getChannelById = function getChannelById(channel_id, env, fn) {
    var url = env === 'production' ? '//h5.lvb.eastmoney.com/lvbcooperation/api/av/GetAVInfo' : '//h5-qas.lvb.eastmoney.com/lvbcooperation/api/av/GetAVInfo';
    return new Promise(function (resolve) {
        jsonp(''.concat(url, '?reqtype=server&channel_id=').concat(channel_id), {}, function (err, json) {
            resolve(getVideoModel(json.data));
        });
    });
};
export var getChannelByUid = function getChannelByUid(user_id, env) {
    var url = env === 'production' ? '//sns.lvb.eastmoney.com/lvbcooperation/api/channel/GetUserChannel' : '//sns-qas.lvb.eastmoney.com/lvbcooperation/api/channel/GetUserChannel';
    return new Promise(function (resolve) {
        jsonp(''.concat(url, '?reqtype=server&user_id=').concat(user_id), {}, function (err, json) {
            resolve(getVideoModel(json.data[0]));
        });
    });
};
function getVideoModel(data) {
    var channel = {};
    if (data.state === 1 && data.hls_downstream_address.length > 0) {
        channel.flv = data.flv_downstream_address;
        channel.hls = data.hls_downstream_address;
        channel.is_live = true;
    } else if (data.state === 4) {
        channel.flv = data.flv_downstream_address;
        channel.hls = data.hls_downstream_address;
        channel.is_foreshow = true;
    } else {
        channel.is_live = false;
        channel.flv = [];
        channel.hls = [];
        channel.mp4 = data.otype_video.find(function (row) {
            return row.file_type === 'mp4';
        });
        channel.mp4 = channel.mp4 ? channel.mp4.file_set : [];
        data.record_hls.video_files.forEach(function (row) {
            channel.hls.push({
                url: row.video_url,
                size: row.video_size,
                duration: row.video_duration
            });
        });
        data.record_file_set.forEach(function (row, index) {
            channel.flv.push({
                url: row,
                size: 0,
                duration: data.record_file_duration[index]
            });
        });
        if (data.type === 11) {
            channel.isAudio = true;
            channel.audio = data.otype_video.find(function (row) {
                return row.file_type === 'mp3' || row.file_type === 'm4a' || row.file_type === 'wav';
            });
            channel.audio = channel.audio ? channel.audio.file_set : [];
        } else {
            channel.isAudio = false;
        }
        channel.del_state = data.del_state;
    }
    channel.id = data.id;
    channel.name = data.name;
    channel.state = data.state;
    channel.start_time = data.start_time;
    channel.foreshow_time = data.foreshow_time;
    channel.end_time = data.end_time;
    channel.poster = data.yun_record_img_url.replace('{w}', 1080).replace('{h}', 1080);
    channel.anchor = data.anchor;
    channel.width = data.width;
    channel.height = data.height;
    channel.ui_state = data.ui_state;
    return channel;
}